var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "dashboard icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "33f6uaqkma",
    x1: 1.206,
    y1: 0.345,
    x2: 0.222,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0379a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f1177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cap2p9127b",
    x1: 1.206,
    y1: 0.345,
    x2: -1.492,
    y2: 0.291,
    xlinkHref: "#33f6uaqkma"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p754dusr7c",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffab00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oadok9v51d",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#900"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.444)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 125",
    transform: "translate(-.444)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 13",
    cx: 20,
    cy: 20,
    r: 20,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 165",
    width: 5.763,
    height: 9.933,
    rx: 2.882,
    transform: "rotate(90 -.921 25.706)",
    style: {
      fill: "url(#33f6uaqkma)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 158",
    d: "M2.719 2.079a.64.64 0 0 0-.64.64v14.713a.64.64 0 0 0 .64.64h22.55a.64.64 0 0 0 .64-.64V2.719a.64.64 0 0 0-.64-.64H2.719m0-2.079h22.55a2.719 2.719 0 0 1 2.719 2.719v14.713a2.719 2.719 0 0 1-2.719 2.719H2.719A2.719 2.719 0 0 1 0 17.432V2.719A2.719 2.719 0 0 1 2.719 0z",
    transform: "translate(5.917 8.339)",
    style: {
      fill: "#0379a0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 159",
    width: 16.008,
    height: 2.576,
    rx: 1.288,
    transform: "translate(11.815 30.599)",
    style: {
      fill: "url(#cap2p9127b)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 163",
    width: 10.89,
    height: 2.256,
    rx: 1.128,
    transform: "translate(9.617 12.074)",
    style: {
      fill: "url(#33f6uaqkma)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 164",
    width: 10.89,
    height: 2.256,
    rx: 1.128,
    transform: "translate(9.617 15.524)",
    style: {
      fill: "url(#33f6uaqkma)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 160",
    width: 6.981,
    height: 6.038,
    rx: 3.019,
    transform: "translate(22.517 11.692)",
    style: {
      fill: "url(#p754dusr7c)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 161",
    width: 6.981,
    height: 4.906,
    rx: 2.453,
    transform: "translate(22.517 19.868)",
    style: {
      fill: "url(#oadok9v51d)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 162",
    width: 10.189,
    height: 4.906,
    rx: 2.453,
    transform: "translate(9.999 19.868)",
    style: {
      fill: "url(#p754dusr7c)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardicon);
export default __webpack_public_path__ + "static/media/dashboard icon.fb4410178170247f186b2cda7e6dc872.svg";
export { ForwardRef as ReactComponent };